import React, { useState ,useEffect} from 'react';
import PropTypes from 'prop-types';
import CloseButton from '../../common/CloseButton/CloseButton';
import './UserEditPopup.css';

const UserLimitViewPopup = ({
  isOpen,
  title,
  date,
  currentLimit,
  historyData,
  onClose
}) => {
  const [showTable, setShowTable] = useState(false);
  const [userCount, setUserCount] = useState(0);
  const [addedUserCount, setAddedUserCount] = useState(0);
  const [removedUserCount, setRemovedUserCount] = useState(0);

  const [formValues, setFormValues] = useState({
    userCount: currentLimit || 0,
    addedUserCount: 0,
    removedUserCount: 0,

  });

  useEffect(() => {
    if (currentLimit !== undefined) {
      setUserCount(currentLimit);
    }
  }, [currentLimit]);

  if (!isOpen) return null;
  const toggleTable = () => {
    setShowTable(!showTable);
  };

  return (
    <div className="popup-overlay">
      <div className="popup user-edit-popup popup2">
        <CloseButton onClick={onClose} />
        <div className="popup-header">
          <h2 className="user-edit-title common-text black fts-20 ftw-5">{title}</h2>
        </div>
        <div className="popup-body user-limit-fields-container">
          <div className="field">
            <p className="common-text left-fields fts-15 ftw-4 black">Current plan user limit</p>
            <p className="common-text right-values fts-15 ftw-5 black">{currentLimit} Users</p>
          </div>
          <div className="field">
            <p className="common-text left-fields fts-15 ftw-4 black">New Added user count</p>
            <p className="common-text right-values fts-15 ftw-4 green">{addedUserCount.toString().padStart(2, '0')}</p>
          </div>
          <div className="field">
            <p className="common-text left-fields fts-15 ftw-4 black">Removed User count</p>
            <p className="common-text right-values fts-15 ftw-4 red">{removedUserCount.toString().padStart(2, '0')}</p>
          </div>

          <div className="history-container">

            <button className="history-button fts-13 ftw-4 common-text dk-gray" onClick={toggleTable} >
                Add / Remove History
                <svg 
                className={`down-svg ${showTable ? 'rotate' : ''}`} width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg" >
                <rect x="25.7017" y="18.4131" width="25" height="18" transform="rotate(180 25.7017 18.4131)" fill="#EBEBEB" />
                <path d="M14.0226 15.1828L9.5393 6.95135L18.9096 7.1844L14.0226 15.1828Z" fill="#424242" />
                </svg>
            </button>

            {showTable && (
              <div className="history-table-container">
                <table className="history-table">
                  <thead className="history-table-head">
                    <tr className="history-table-tr" style={{ borderBottom: '1px solid #606060' }}>
                      <th className="common-text fts-12 ly-gray ftw-4">Date</th>
                      <th className="common-text fts-12 ly-gray ftw-4">Count</th>
                      <th className="common-text fts-12 ly-gray ftw-4">Bank</th>
                    </tr>
                  </thead>
                  <tbody className="history-tbody">
                    {historyData.map((history, index) => (
                      <tr
                        key={index}
                        className="history-tbody-tr common-text fts-14 black"
                        style={{ borderBottom: index < historyData.length - 1 ? '1px solid #606060' : 'none' }}
                      >
                        <td className={`common-text fts-12 ftw-4 ${history.manage_type === 'Add' ? 'green' : 'red'}`}>{history.date}</td>
                        <td className={`common-text fts-12 ftw-4 ${history.manage_type === 'Add' ? 'green' : 'red'}`}>
                          {history.count} {history.action}
                        </td>
                        <td className="common-text fts-12 black ftw-4">
                          <span className="user-payment">{history.payment_method}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

UserLimitViewPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  currentLimit: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  date: PropTypes.func.isRequired,
};

export default UserLimitViewPopup;